import { FormattedMessage } from "react-intl";

export const FixedTopics = {
  life: {
    text: <FormattedMessage defaultMessage="Life" />,
    tags: [
      "life",
      "lifestyle",
      "dailyinspiration",
      "motivation",
      "lifelessons",
      "personaldevelopment",
      "happiness",
      "wellbeing",
      "mindfulness",
      "selfcare",
      "positivity",
      "growth",
      "inspiration",
      "lifegoals",
      "mindset",
      "joy",
      "balance",
      "fulfillment",
      "purpose",
      "living",
      "lifetips",
      "lifehacks",
      "wellness",
      "lifejourney",
      "enjoylife",
      "simplepleasures",
      "gratitude",
      "lifeadvice",
      "lifecoaching",
      "lifelove",
    ],
  },
  science: {
    text: <FormattedMessage defaultMessage="Science" />,
    tags: [
      "science",
      "research",
      "innovation",
      "technology",
      "biology",
      "physics",
      "chemistry",
      "astronomy",
      "environment",
      "ecology",
      "geology",
      "neuroscience",
      "genetics",
      "data",
      "experiment",
      "theory",
      "discovery",
      "engineering",
      "mathematics",
      "robotics",
      "artificialintelligence",
      "climate",
      "space",
      "quantum",
      "microbiology",
      "biotechnology",
      "nanotechnology",
      "pharmacology",
      "astrophysics",
      "scientificmethod",
    ],
  },
  nature: {
    text: <FormattedMessage defaultMessage="Nature" />,
    tags: [
      "nature",
      "wildlife",
      "forest",
      "mountains",
      "rivers",
      "oceans",
      "flora",
      "fauna",
      "ecosystem",
      "biodiversity",
      "conservation",
      "habitat",
      "landscape",
      "outdoors",
      "environment",
      "geography",
      "earth",
      "climate",
      "naturalbeauty",
      "wilderness",
      "green",
      "sustainability",
      "wildlifeconservation",
      "nationalpark",
      "gardening",
      "hiking",
      "birdwatching",
      "ecotourism",
      "photography",
      "naturelovers",
    ],
  },
  business: {
    text: <FormattedMessage defaultMessage="Business" />,
    tags: [
      "business",
      "entrepreneurship",
      "marketing",
      "finance",
      "innovation",
      "management",
      "startup",
      "leadership",
      "economics",
      "strategy",
      "branding",
      "sales",
      "technology",
      "investment",
      "networking",
      "growth",
      "corporate",
      "customer",
      "market",
      "productivity",
      "advertising",
      "ecommerce",
      "analytics",
      "humanresources",
      "globalbusiness",
      "digitalmarketing",
      "socialmedia",
      "sustainability",
      "entrepreneur",
      "businessdevelopment",
    ],
  },
  game: {
    text: <FormattedMessage defaultMessage="Game" />,
    tags: [
      "gaming",
      "videogames",
      "esports",
      "multiplayer",
      "onlinegaming",
      "gameplay",
      "streaming",
      "gamer",
      "console",
      "pcgaming",
      "mobilegaming",
      "gamedevelopment",
      "virtualreality",
      "roleplaying",
      "strategygames",
      "actiongames",
      "simulation",
      "indiegames",
      "adventuregames",
      "puzzle",
      "fantasy",
      "scifi",
      "horror",
      "sports",
      "racing",
      "fighting",
      "platformer",
      "mmorpg",
      "retrogaming",
      "arcade",
    ],
  },
  sport: {
    text: <FormattedMessage defaultMessage="Sport" />,
    tags: [
      "sports",
      "athletics",
      "soccer",
      "basketball",
      "baseball",
      "football",
      "tennis",
      "golf",
      "swimming",
      "running",
      "cycling",
      "volleyball",
      "hockey",
      "skiing",
      "boxing",
      "martialarts",
      "gymnastics",
      "cricket",
      "rugby",
      "tabletennis",
      "badminton",
      "fishing",
      "archery",
      "bowling",
      "surfing",
      "skateboarding",
      "motorsports",
      "equestrian",
      "fitness",
      "yoga",
    ],
  },
  photography: {
    text: <FormattedMessage defaultMessage="Photography" />,
    tags: [
      "photography",
      "landscape",
      "portrait",
      "naturephotography",
      "streetphotography",
      "blackandwhite",
      "travelphotography",
      "macro",
      "wildlifephotography",
      "urbanphotography",
      "nightphotography",
      "fashionphotography",
      "fineartphotography",
      "documentary",
      "sportsphotography",
      "foodphotography",
      "architecturalphotography",
      "candid",
      "aerialphotography",
      "underwaterphotography",
      "filmphotography",
      "digitalphotography",
      "photographytips",
      "photoediting",
      "photographygear",
      "lighting",
      "composition",
      "exposure",
      "photographyworkshop",
      "photographyart",
    ],
  },
};
